import { CAMERA_SELECTED_COLORS, COLORS } from 'helpers/globals'

export default {
  colorPicker: {
    padding: '.4rem',
    marginTop: '.5rem',
    borderRadius: 2,
    position: 'absolute',
    top: '3.5rem',
    right: '-2.5rem',
    cursor: 'default',
    width: 78,
    height: 58,
    border: '1px solid #bfbfbf',
    background: 'white',
    zIndex: 1,
    fontSize: '1.6rem',
    flexWrap: 'wrap',
    alignItems: 'center'
  },
  color: {
    height: 20,
    width: 20,
    cursor: 'pointer',
    display: 'flex',
    border: '1px solid #6c6c6c',
    borderRadius: '50%',
    '&:not(:nth-of-type(3n+0))': { marginRight: '.4rem' },
    '&:hover': { boxShadow: `0 0 3px 1px ${COLORS.secondary}` }
  },
  checkIcon: {
    margin: 'auto',
    fontSize: '1.2rem',
    color: 'white'
  },
  picker: {
    cursor: 'pointer'
  },
  colorWrapper: {
    display: 'inline-block',
    position: 'relative'
  },
  fillIcon: {
    fontSize: '2.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/CameraConfig/CameraColorPicker/style.js